import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_tooltip, { location: "top" }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn_icon, _mergeProps(props, {
          icon: "$oss-fast-forward",
          size: "x-small",
          variant: "flat",
          color: _ctx.buttonColor,
          class: "mx-1 enlarge-oss-fast-forward",
          "data-cy": "DocumentValidationSpeedRun-btn",
          onClick: _ctx.onButtonClick
        }), null, 16, ["color", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", { innerHTML: _ctx.buttonTitle }, null, 8, _hoisted_1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.displaySnackbar,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.displaySnackbar) = $event)),
      color: "success",
      timeout: "5000"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          color: "whilte",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeSnackbar()))
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" × ")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", { innerHTML: _ctx.snackbarMessage }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}